module.exports = __webpack_public_path__ + "static/media/alarm-sound.3b64cd8a.wav";


//////////////////
// WEBPACK FOOTER
// ./src/alarm-sound.wav
// module id = 262
// module chunks = 0